import { useEffect } from 'react';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import useGradesTableStore from '../store/useGradesTableStore';

const useAssignments = () => {
  const studentId = useGradesTableStore(state => state.student.id);
  const programId = useGradesTableStore(state => state.programId);
  const lesson = useGradesTableStore(state => state.lesson);
  const unit = useGradesTableStore(state => state.unit);
  const classroom = useGradesTableStore(state => state.classroom);
  const setStore = useGradesTableStore(state => state.setStore);

  useEffect(() => {
    if (!programId || !studentId || !classroom) return;

    const searchParams = {
      extra_attributes: ['assignment_details'],
      for_classroom: classroom.id,
      in_program: programId,
    };

    if (lesson) {
      searchParams['in_lesson'] = lesson.id;
    } else {
      searchParams['in_unit'] = unit.id;
    }

    axios.get(Routes.plato_api_student_index_student_assignments_path(studentId, searchParams))
      .then((res) => {
        setStore({ assignments: res.data.data || [] });
      })
      .finally(() => setStore({ isLoadingAssignments: false }));
  }, []);
};

export default useAssignments;
